/* Wear It With — click delegation, no-variants action, fallback action */
(function () {
  if (window.__wiwHandlerInit) return;
  window.__wiwHandlerInit = true;

  document.addEventListener('click', handleCardClick, true);

  function handleCardClick(event) {
    const card = event.target.closest('.wiw-card[data-wiw-quick-add-zone]');
    if (!card) return;

    const zone = card.dataset.wiwQuickAddZone;
    const isButton = !!event.target.closest('.wiw-quick-add-btn');
    const isImage = !!event.target.closest('.wiw-card__media-wrapper');

    const inPrimaryZone =
      isButton ||
      (zone === 'button-image' && isImage) ||
      (zone === 'container');

    const quickAddValid = card.dataset.wiwQuickAddValid === 'true';

    if (!inPrimaryZone) {
      // Outside primary zone — apply Setting 3 (fallback action).
      event.preventDefault();
      event.stopPropagation();
      executeAction(card.dataset.wiwFallbackAction || 'product-page', card);
      return;
    }

    if (quickAddValid && isButton) {
      // Native + button click for a product with variants —
      // let modal-opener (bubble-phase) fire normally.
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (quickAddValid) {
      // Image or container click on a variant product — delegate to + button.
      const btn = card.querySelector('.wiw-quick-add-btn');
      if (btn) btn.click();
      return;
    }

    // No-variants product — apply Setting 2.
    let action = card.dataset.wiwNoVariantsAction || 'product-page';
    if (action === 'fallback') {
      action = card.dataset.wiwFallbackAction || 'product-page';
    }
    executeAction(action, card);
  }

  function executeAction(action, card) {
    switch (action) {
      case 'product-page':
        navigate(card.dataset.wiwProductUrl, card.dataset.wiwFallbackTarget);
        return;
      case 'custom-url':
      case 'collection-specific':
      case 'collections-all':
        navigate(card.dataset.wiwFallbackUrl, card.dataset.wiwFallbackTarget);
        return;
      case 'atc-drawer':
        addToCartAndOpenDrawer(card);
        return;
      case 'atc-alert':
        addToCartAndAlert(card);
        return;
      case 'quick-add':
        openQuickAddModal(card);
        return;
      case 'fallback':
        executeAction(card.dataset.wiwFallbackAction || 'product-page', card);
        return;
      case 'nothing':
        return;
    }
  }

  function openQuickAddModal(card) {
    const modalSelector = card.dataset.wiwModalId;
    if (!modalSelector) return;
    const modal = document.querySelector(modalSelector);
    if (!modal || typeof modal.show !== 'function') return;
    const btn = card.querySelector('.wiw-quick-add-btn');
    if (!btn) return;
    // Call modal.show() directly — synthetic-clicking the button would
    // re-enter handleCardClick on the next capture-phase pass.
    modal.show(btn);
  }

  function navigate(url, target) {
    if (!url) return;
    if (target === '_blank') {
      window.open(url, '_blank', 'noopener');
    } else {
      window.location.href = url;
    }
  }

  async function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    const cartUI =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    let sections = '';
    if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
      try {
        sections = cartUI.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      } catch (e) { /* getSectionsToRender threw — proceed without sections */ }
    }

    const body = sections
      ? JSON.stringify({ items: [{ id: variantId, quantity: quantity }], sections: sections })
      : JSON.stringify({ items: [{ id: variantId, quantity: quantity }] });

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript'
      },
      body: body
    });

    if (!res.ok) {
      const errText = await res.text();
      throw new Error('Add to cart failed: ' + res.status + ' — ' + errText);
    }
    return res.json();
  }

  function setButtonLoading(card, isLoading) {
    const btn = card.querySelector('.wiw-quick-add-btn');
    if (!btn) return;
    const spinner = btn.querySelector('.loading-overlay__spinner');
    if (isLoading) {
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  async function addToCartAndOpenDrawer(card) {
    const variantId = card.dataset.wiwProductId;
    if (!variantId) return;
    setButtonLoading(card, true);
    try {
      const data = await addToCart(variantId);
      const cartUI =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      // Shine stamps `is-empty` onto the <cart-drawer> wrapper server-side
      // when the cart is empty. cart-drawer.renderContents() only checks a
      // descendant for that class, so the wrapper keeps it after the add —
      // and CSS then collapses .drawer__header/body/footer to height:0,
      // producing a blank, "inescapable" drawer. The standard product-form
      // path strips this in its submit finally block; we mirror it here.
      if (cartUI) {
        cartUI.classList.remove('is-empty');
        const items = cartUI.querySelector('cart-drawer-items');
        if (items) items.classList.remove('is-empty');
      }

      if (cartUI && typeof cartUI.renderContents === 'function') {
        cartUI.renderContents(data);
      } else if (cartUI && typeof cartUI.open === 'function') {
        cartUI.open();
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    } catch (err) {
      console.error('[Wear It With] Add to cart failed:', err);
      showAlert('Could not add to cart', true);
    } finally {
      setButtonLoading(card, false);
    }
  }

  async function addToCartAndAlert(card) {
    const variantId = card.dataset.wiwProductId;
    if (!variantId) return;
    setButtonLoading(card, true);
    try {
      await addToCart(variantId);
      const title = card.dataset.wiwProductTitle || 'Item';
      showAlert('Added "' + title + '" to cart', false);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('[Wear It With] Add to cart failed:', err);
      showAlert('Could not add to cart', true);
    } finally {
      setButtonLoading(card, false);
    }
  }

  function showAlert(message, isError) {
    const existing = document.querySelector('.wiw-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'wiw-toast' + (isError ? ' wiw-toast--error' : '');
    toast.setAttribute('role', isError ? 'alert' : 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('wiw-toast--visible');
    });

    setTimeout(function () {
      toast.classList.remove('wiw-toast--visible');
      setTimeout(function () { toast.remove(); }, 320);
    }, 2400);
  }
})();
